function Footer() {
  return (
    <footer className="bg-[#F5F5F7] py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/c3b3b2cd4ef57e1a57418aa386255ad3.png"
              alt="Wazier AI"
              className="h-8 w-auto mb-4"
            />
            <p className="text-sm text-gray-500 font-light max-w-md">
              Intelligent Systems for Service Businesses
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div className="space-y-3">
              <h4 className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4">Navigate</h4>
              <a href="/" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                Home
              </a>
              <a href="#solutions" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                Solutions
              </a>
            </div>
            <div className="space-y-3">
              <h4 className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4">Company</h4>
              <a href="#industries" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                Industries
              </a>
              <a href="#process" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                Process
              </a>
              <a href="#contact" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                Contact
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-400">
          <p>&copy; 2026 Wazier AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;